import { Suspense } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import IntroStrip from "@/components/IntroStrip";
import Gallery from "@/components/Gallery";
import BottomNav from "@/components/BottomNav";
import DisclaimerBanner from "@/components/DisclaimerBanner";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

import AnimatedSection from "@/components/AnimatedSection";

// Lazy load below-fold sections
const Features = lazyWithRetry(() => import("@/components/Features"));
const FeaturesAmenities = lazyWithRetry(() => import("@/components/Features").then(m => ({ default: m.FeaturesAmenities })));
const EfficientLayouts = lazyWithRetry(() => import("@/components/EfficientLayouts"));
const ConstructionSection = lazyWithRetry(() => import("@/components/sections/ConstructionSection"));
const PlotsSection = lazyWithRetry(() => import("@/components/sections/PlotsSection"));
const MasterPlanSection = lazyWithRetry(() => import("@/components/sections/MasterPlanSection"));
const LayoutsSection = lazyWithRetry(() => import("@/components/sections/LayoutsSection"));
const LocationSection = lazyWithRetry(() => import("@/components/LocationSection"));
const ExploreSection = lazyWithRetry(() => import("@/components/sections/ExploreSection"));
const FAQSection = lazyWithRetry(() => import("@/components/sections/FAQSection"));
const ReferencesSection = lazyWithRetry(() => import("@/components/sections/ReferencesSection"));
const ContactSection = lazyWithRetry(() => import("@/components/sections/ContactSection"));
const Footer = lazyWithRetry(() => import("@/components/Footer"));
const WhatsAppChat = lazyWithRetry(() => import("@/components/WhatsAppChat"));
const JobsiteMedia = lazyWithRetry(() => import("@/components/JobsiteMedia"));

const LazyFallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  return (
    <div className="min-h-screen pb-[4.5rem] md:pb-0">
      <Navigation />
      <main>
        <section id="home">
          <Hero />
        </section>
        
        <IntroStrip />
        
        <AnimatedSection>
          <section id="gallery">
            <Gallery />
          </section>
        </AnimatedSection>
        
        <Suspense fallback={<LazyFallback />}>
          <AnimatedSection delay={0.1}>
            <LayoutsSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <EfficientLayouts />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <ConstructionSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <FeaturesAmenities />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <PlotsSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <MasterPlanSection />
          </AnimatedSection>

          <AnimatedSection>
            <Features />
          </AnimatedSection>

          <AnimatedSection>
            <LocationSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <ExploreSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <ReferencesSection />
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <FAQSection />
          </AnimatedSection>

          <AnimatedSection>
            <ContactSection />
          </AnimatedSection>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <WhatsAppChat />
      </Suspense>
      
      
      <BottomNav />
      <Suspense fallback={null}>
        <JobsiteMedia />
      </Suspense>
    </div>
  );
};

export default Index;
